import React from "react";
import { Layout } from "../pages/layout/Layout";
import { ArtistHome } from "../pages/artists/home/ArtistHome";
import { Route } from "react-router-dom";
import { Participate } from "../pages/artists/contests/Participate";
import { ViewContest } from "../pages/admin/contests/ViewContest";
import { CommentContests } from "../pages/admin/contests/CommentContest";

import { ProfileView } from "../pages/artists/profile/ProfileView";
import { Notifications } from "../pages/notification/Notifications";
import { ArtistsList } from "../pages/admin/artists/ArtistsList";
import { Contests } from "../pages/contest/Contest";
import ProtectedRoute from "./ProtectedRoute";
import { ArtistContestDetail } from "../pages/artists/contests/ArtistContestDetail";
import { UserRequests } from "../pages/artists/contest-requests/UserRequests";
import { YourContests } from "../pages/artists/contests/YourContests";
import { DesignContestDetail } from "../pages/artists/contests/DesignContestDetail";
import { RequestDetail } from "../pages/artists/contests/RequestDetail";
import MyRewards from "../pages/artists/rewards/MyRewards";
import ArtistProfile from "../pages/profile/ArtistProfile";
import Earning from "../pages/admin/earning/Earning";
import { ContestResult } from "../pages/admin/contests/ContestResult";



export const ArtistRoutes = () => (
  <Route element={<ProtectedRoute />}>
    <Route path="/artist" element={<Layout />}>
      <Route index element={<ArtistHome />} />
      <Route path="view-contests" element={<ViewContest />} />
      <Route path="participate-contests" element={<Participate />} />
      <Route path="comments-contests" element={<CommentContests />} />
      <Route path="profile-view" element={<ProfileView />} />
  
      <Route path="notifications" element={<Notifications />} />
      <Route path="artist-list" element={<ArtistsList />} />
      <Route path="user-requests" element={<UserRequests />} />
      <Route path="profile/:userId" element={<ArtistProfile />} />
         <Route path="artist-profile/:userId" element={<ArtistProfile />} />
     
      <Route path="contests/:statusCode" element={<Contests />} />
      <Route
        path="contest-detail/:purpose/:contestId"
        element={<ArtistContestDetail />}
      />
      <Route path="contest-results/:contestId" element={<ContestResult />} />
      <Route path="request-detail/:requestId" element={<RequestDetail />} />

      <Route path="your-contest" element={<YourContests />} />
      <Route
        path="design-detail/:contestId"
        element={<DesignContestDetail />}
      />
      
      <Route path="my-rewards" element={<MyRewards />} />
      <Route path="my-earnings/:artistId" element={<Earning />} />
    </Route>
  </Route>
);
